"use client";

import { memo } from "react";
import { SubCategory } from "@/lib/interfaces/cards";
import styles from "../cardList.module.scss";

interface SubCategoriesScrollProps {
  subCategories: SubCategory[];
}

function SubCategoriesScroll({ subCategories }: SubCategoriesScrollProps) {
  if (subCategories.length === 0) return null;

  return (
    <div className={`overflow-x-auto mb-4 pb-2 ${styles.filtersScroll}`}>
      <div className="flex gap-2">
        {subCategories.map((subCat) => (
          <button
            key={subCat.id}
            className="px-4 py-2 bg-white border border-gray-300 rounded-full text-sm whitespace-nowrap hover:bg-gray-100"
          >
            {subCat.category_name}
          </button>
        ))}
      </div>
    </div>
  );
}

export default memo(SubCategoriesScroll);